import React from "react";
import { BaseEdge } from "@xyflow/react";

const EdgeHoverHandler = ({
  edgePath,
  markerEnd,
  style,
  id,
  strokeWidth = 20,
  isHovered,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: 1,
          stroke: isHovered ? "#1976d2" : style.stroke || "#444",
          transition: "stroke 0.2s",
        }}
        id={id}
      />

      {/* Invisible wider path for hover detection */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={strokeWidth}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ cursor: "pointer" }}
      />
    </>
  );
};

export default EdgeHoverHandler;
